// extracted by mini-css-extract-plugin
export default {"main":"TheFooter_main__rL3KX","left":"TheFooter_left__ys97i","right":"TheFooter_right__nzUKt","entry":"TheFooter_entry__4enQM"};